<div class="break-word body-3" [class.collapsed]="collapsed">
  <ng-container *ngIf="text">
    {{ text.length <= maxLength ? text : !collapsed ? text : (text | trim : maxLength) + "..." }}
    <a *ngIf="text.length > maxLength" class="link bold" (click)="collapsed = !collapsed">
      <span>{{ (collapsed ? 'general.api_read_more' : 'general.api_read_less') | translate }}</span>
    </a>
  </ng-container>
  <span class="text-muted" *ngIf="!text">-</span>
</div>

